export const CREATE_CAMPAIGN_REQUEST = 'campaign/CREATE_CAMPAIGN_REQUEST';
export const CREATE_CAMPAIGN_SUCCESS = 'campaign/CREATE_CAMPAIGN_SUCCESS';
export const CREATE_CAMPAIGN_FAILURE = 'campaign/CREATE_CAMPAIGN_FAILURE';

export const READ_CAMPAIGN_REQUEST = 'campaign/READ_CAMPAIGN_REQUEST';
export const READ_CAMPAIGN_SUCCESS = 'campaign/READ_CAMPAIGN_SUCCESS';
export const READ_CAMPAIGN_FAILURE = 'campaign/READ_CAMPAIGN_FAILURE';

export const READ_CURRENT_CAMPAIGN_REQUEST = 'campaign/READ_CURRENT_CAMPAIGN_REQUEST';
export const READ_CURRENT_CAMPAIGN_SUCCESS = 'campaign/READ_CURRENT_CAMPAIGN_SUCCESS';
export const READ_CURRENT_CAMPAIGN_FAILURE = 'campaign/READ_CURRENT_CAMPAIGN_FAILURE';

export const UPDATE_CAMPAIGN_REQUEST = 'campaign/UPDATE_CAMPAIGN_REQUEST';
export const UPDATE_CAMPAIGN_SUCCESS = 'campaign/UPDATE_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_FAILURE = 'campaign/UPDATE_CAMPAIGN_FAILURE';

export const DELETE_CAMPAIGN_REQUEST = 'campaign/DELETE_CAMPAIGN_REQUEST';
export const DELETE_CAMPAIGN_SUCCESS = 'campaign/DELETE_CAMPAIGN_SUCCESS';
export const DELETE_CAMPAIGN_FAILURE = 'campaign/DELETE_CAMPAIGN_FAILURE';

export const READ_CAMPAIGNS_REQUEST = 'campaign/READ_CAMPAIGNS_REQUEST';
export const READ_CAMPAIGNS_SUCCESS = 'campaign/READ_CAMPAIGNS_SUCCESS';
export const READ_CAMPAIGNS_FAILURE = 'campaign/READ_CAMPAIGNS_FAILURE';


// WEBPACK FOOTER //
// ./src/modules/campaign/campaign.actionTypes.js